import { BoxProps, HStack, useColorMode } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { AdaptationMode } from '../../../components/layout/PageLayout';
import CustomButton from '../../../iZUMi-UI-toolkit/src/components/Buttons/CustomButton/CustomButton';
import { getColorThemeSelector } from '../../../utils/funcs';

type Props = {
    dex: 'iZi' | 'uni';
    type?: AdaptationMode;
} & BoxProps;

const TypeSelect: React.FC<Props> = (props) => {
    const { type } = props;
    const { t } = useTranslation();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const { dex, ...rest } = props;
    const history = useHistory();
    const location = useLocation();

    return type === 'mobile' ? (
        <HStack w="342px" alignItems="start" justifyContent="start" spacing="15px" {...rest}>
            <CustomButton
                bg={location.pathname === `/farm/dynamic` ? 'linear-gradient(93.8deg, #8755FF 2.26%, #5829C8 112.45%)' : 'inherit'}
                _selected={{}}
                border="none"
                color={location.pathname === `/farm/dynamic` ? '#ffffff' : '#9E96AF'}
                fontFamily={location.pathname !== `/farm/dynamic` ? 'Montserrat' : 'Montserrat-Bold'}
                onClick={() => {
                    location.pathname !== `/farm/dynamic` && history.push(`/farm/dynamic`);
                }}
                borderRadius="3px"
                text={t('Dynamic')}
                h="25px"
                w="80px"
                fontSize="12px"
                letterSpacing="0.02em"
            />
            <CustomButton
                bg={location.pathname === `/farm/fix` ? 'linear-gradient(93.8deg, #8755FF 2.26%, #5829C8 112.45%)' : 'inherit'}
                border="none"
                _selected={{}}
                color={location.pathname === `/farm/fix` ? '#ffffff' : '#9E96AF'}
                fontFamily={location.pathname !== `/farm/fix` ? 'Montserrat' : 'Montserrat-Bold'}
                onClick={() => {
                    location.pathname !== `/farm/fix` && history.push(`/farm/fix`);
                }}
                borderRadius="3px"
                text={t('Fix Range')}
                h="25px"
                w="80px"
                fontSize="12px"
            />

            <CustomButton
                bg={location.pathname === `/farm/one-side` ? 'linear-gradient(93.8deg, #8755FF 2.26%, #5829C8 112.45%)' : 'inherit'}
                border="none"
                _selected={{}}
                color={location.pathname === `/farm/one-side` ? '#ffffff' : '#9E96AF'}
                fontFamily={location.pathname !== `/farm/one-side` ? 'Montserrat' : 'Montserrat-Bold'}
                onClick={() => {
                    location.pathname !== `/farm/one-side` && history.push(`/farm/one-side`);
                }}
                borderRadius="3px"
                text={t('One Side')}
                h="25px"
                w="80px"
                fontSize="12px"
            />
        </HStack>
    ) : (
        <HStack
            w="100%"
            alignItems="start"
            // justifyContent={{ base: 'space-between' }}
            justifyContent="end"
            spacing="20px"
            {...rest}
        >
            <CustomButton
                variant={location.pathname === `/farm/fix` ? 'purple' : 'outlinePurple'}
                onClick={() => {
                    location.pathname !== `/farm/fix` && history.push(`/farm/fix`);
                }}
                borderRadius="3px"
                text={t('Fix Range')}
                h="30px"
                w="130px"
                px="10px"
                fontSize="12px"
            />

            <CustomButton
                variant={location.pathname === `/farm/one-side` ? 'purple' : 'outlinePurple'}
                onClick={() => {
                    location.pathname !== `/farm/one-side` && history.push(`/farm/one-side`);
                }}
                borderRadius="3px"
                text={t('One Side')}
                h="30px"
                w="130px"
                px="10px"
                fontSize="12px"
            />

            <CustomButton
                variant={location.pathname === `/farm/dynamic` ? 'purple' : 'outlinePurple'}
                onClick={() => {
                    location.pathname !== `/farm/dynamic` && history.push(`/farm/dynamic`);
                }}
                borderRadius="3px"
                text={t('Dynamic')}
                h="30px"
                w="130px"
                px="10px"
                fontSize="12px"
            />
        </HStack>
    );
};

export default TypeSelect;
